import { useKeycloak } from "@react-keycloak/web";
import "font-awesome/css/font-awesome.min.css";
import { Fragment } from "react";
import Loader from "./layout/loader/loader";
const App: React.FC = ({ children }) => {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return <Loader />;
  }
  return (
    <Fragment>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div>{children}</div>
        </div>
      </div>
    </Fragment>
  );
};

export default App;
